import schema from "../page/schema"
export default schema